import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { containerFlagApi } from '@/lib/api/services/container-flag.api';
import type { FlagCode } from '@/types/container-flag';

export const containerFlagKeys = {
  all: ['container-flags'] as const,
};

/** What the tenant's flag colours mean. Read by anyone who can read a recipe. */
export function useContainerFlags(enabled = true) {
  return useQuery({
    queryKey: containerFlagKeys.all,
    queryFn: () => containerFlagApi.get(),
    enabled,
  });
}

export function useUpdateContainerFlags() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (codes: FlagCode[]) => containerFlagApi.update(codes),
    onSuccess: (data) => {
      queryClient.setQueryData(containerFlagKeys.all, data);
    },
  });
}
